import { render, staticRenderFns } from "./EmployeeIdUpload.vue?vue&type=template&id=53e25867"
import script from "./EmployeeIdUpload.vue?vue&type=script&lang=ts"
export * from "./EmployeeIdUpload.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports